import { createSelector } from 'reselect';
import moment from 'moment-timezone';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import UserStore from '../../../../stores/UserStore';
import { getTranslation } from '../../../../helpers/translationHelper';
import config from '../../../../config';

const reportFormatter = ReportComponent.formatter;
const reportUtils = ReportComponent.utils;

const today = (state) => state.dashboard.today.data || [];
const parameters = (state) => state.dashboard.today.parameters || {};
const last = (state) => state.dashboard.last.data || [];

export const mainSelector = createSelector(
    today,
    last,
    parameters,
    (todayData = [], lastData = [], params = {}) => {
        const dataDays = _getDataDays(todayData, lastData);
        const t = getTranslation('dashboard', {});
        const data = {
            PublisherCreditTotalAmountConfirmed: {
                title: reportUtils.getTitleChain('PublisherCreditTotalAmountConfirmed'),
                subTitle: t.subtitleIncome || ''
            },
            ActionTypeLeadCountConfirmed: {
                title: reportUtils.getTitleChain('ActionTypeLeadCountConfirmed'),
                subTitle: t.subtitleLeads || ''
            },
            ActionTypeSaleCountConfirmed: {
                title: reportUtils.getTitleChain('ActionTypeSaleCountConfirmed'),
                subTitle: t.subtitleSales || ''
            },
            Visits: {
                title: reportUtils.getTitleChain('Visits'),
                subTitle: t.subtitleConversions || ''
            }
        };

        for (const key in data) {
            const item = data[key];
            const valueToday = +dataDays.today[key] || 0;
            const valueYesterday = +dataDays.yesterday[key] || 0;
            let diff = 100;
            if (valueToday !== 0 && valueYesterday !== 0) {
                diff = Math.abs(((valueToday - valueYesterday) / valueYesterday) * 100);
            } else if (valueToday === 0 && valueYesterday === 0) {
                diff = 0;
            }
            item.today = reportFormatter.format(dataDays.fullToday[key] || 0, key, params);
            item.diffSing = Math.sign(valueToday - valueYesterday);
            item.diff = Math.round(diff) || 0;
        }

        return data;
    }
);

const _getDataDays = (data, lastData) => {
    let today = {};
    let fullToday = {};
    let yesterday = {};
    const formatToday = moment().format(config.reportDateFormat);
    const formatYesterday = moment().subtract(1, 'days').format(config.reportDateFormat);

    data.forEach((d) => {
        if (formatToday === d.GroupBy) today = d;
        if (formatYesterday === d.GroupBy) yesterday = d;
    });

    lastData.forEach((d) => {
        if (formatToday === d.GroupBy) fullToday = d;
    });

    return { today, fullToday, yesterday };
};
